import { useState } from "react";
import styled from "styled-components";
import { useAppSelector } from "../app/hooks";
import { companyState } from "../app/reducers/company-slice";
import { CompanyWithCollaborativesFormDialog } from "../components/dialog/CompanyFormDialog";
import { CompanyPanel } from "../components/panel/CompanyPanel";
import theme from "../style/theme";
import useDidMountEffect from "../utils/custom-hook/use-did-mount-effect";

export const CompanyView = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const { selectedCompanyWithCollaboratives } = useAppSelector(companyState);

  const handleClickDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleClickDialogClose = () => {
    setDialogOpen(false);
  };

  useDidMountEffect(() => {
    if (selectedCompanyWithCollaboratives) {
      handleClickDialogOpen();
    } else {
      handleClickDialogClose();
    }
  }, [selectedCompanyWithCollaboratives]);

  return (
    <CompanyViewContainer>
      <CompanyViewTitle>회사관리</CompanyViewTitle>
      <CompanyViewContent>
        <CompanyPanel
          handleClickDialogOpen={handleClickDialogOpen}
          handleClickDialogClose={handleClickDialogClose}
        />
      </CompanyViewContent>
      {dialogOpen && (
        <CompanyWithCollaborativesFormDialog
          handleClickDialogClose={handleClickDialogClose}
        />
      )}
    </CompanyViewContainer>
  );
};

const CompanyViewContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CompanyViewTitle = styled.div`
  width: 61%;
  padding: 1.5rem 0;
  color: ${theme.palette.primitives.black};
  font-size: 1.25rem;
  font-family: "Pretendard";
  font-style: normal;
  font-weight: 700;
  line-height: 1.5rem;
`;

const CompanyViewContent = styled.div`
  width: 61%;
`;
